import { useEffect } from 'react';

import useFaceVerification from '@/hooks/useFaceVerification';

import FaceVerificationModal from '../FaceVerificationModal';
import RetryModal from '../FaceVerificationModal/retryModal';

interface FaceVerificationProps {
  entityId: string;
  setPauseActivity?: React.Dispatch<React.SetStateAction<boolean>>;
}

const FaceVerification: React.FC<FaceVerificationProps> = ({ entityId, setPauseActivity }) => {
  const {
    verificationStatus,
    isCameraReady,
    videoRef,
    captureImageFromVideo,
    verifyImage,
    isFaceVerificationModelOpen,
    noOfAttenptsLeft,
    isRetryDialogOpen,
    setIsRetryDialogOpen,
    setIsFaceVerificationModalOpen,
    allowAccess,
  } = useFaceVerification({
    entityId,
  });

  // pause activity if face verification does not allow access
  useEffect(() => {
    setPauseActivity?.(!allowAccess);
  }, [allowAccess, setPauseActivity]);

  if (isFaceVerificationModelOpen) {
    return (
      <FaceVerificationModal
        captureImageFromVideo={captureImageFromVideo}
        isCameraReady={isCameraReady}
        verifyImage={verifyImage}
        videoRef={videoRef}
      />
    );
  } else if (isRetryDialogOpen) {
    return (
      <RetryModal
        message={verificationStatus?.message}
        noOfAttenptsLeft={noOfAttenptsLeft}
        setIsFaceVerificationModalOpen={setIsFaceVerificationModalOpen}
        setIsRetryDialogOpen={setIsRetryDialogOpen}
      />
    );
  }
  return null;
};

export default FaceVerification;
